module.exports = __webpack_public_path__ + "assets/functionalityLogOut-7a6a4f.svg";